<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
          >
            <span>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="搜尋名稱"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn
          v-if="canEditClient"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="isShowDialog = true;editingId=-1"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <client-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @edit="showEditDialog"
        @remove="deleteItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>


        <client-addedit-dialog
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
        />

        <v-snackbar
          v-model="isDataRefetched"
          :timeout="-1"
        >
          偵測到資料已更新
          <v-btn
            class="ml-1 mr-1"
            color="pink"
            text
            @click="isDataRefetched = false"
          >
            關閉
          </v-btn>
          <v-btn
            class="ml-1 mr-1"
            color="white"
            text
            @click="reloadDataTable"
          >
            重新載入
          </v-btn>
        </v-snackbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientAddeditDialog from "@/ui/management/client/client-addedit-dialog.vue";
import ClientListItem from "./client-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-client.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";

import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [mixinDelaySearch],
  components: {
    ClientAddeditDialog,
    ClientListItem
  },
  data: () => ({
    isLoading: false,
    // data table
    pageTitle: "客戶",
    dataTable: [],
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // addedit
    isShowDialog: false,
    editingId: -1,
    // data refetched
    isDataRefetched: false
  }),
  computed: {
    headers() {
      let actionHeader = {
        text: "操作",
        value: "action",
        showInMobile: true
      };
      return [
        {
          text: "客戶名稱",
          value: "Name",
          showInMobile: true
        },
        {
          text: "所在縣市",
          value: "county-name",
          showInMobile: true
        }
      ].concat(this.canEditClient ? [actionHeader] : []);
    },
    ...mapGetters(["canEditClient", "myLevel", "clients"])
  },
  methods: {
    exportExcel() {
      let datas = this.dataTable.filter(
        o => !this.search || o.Name.includes(this.search)
      );
      let result = XMLGenerator.generate(this, datas);
      

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-客戶-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.client.list.indexOf(item);

      this.isLoading = true;
      this.$services.client
        .inActivate(this, item.ID)
        .then(res => {
          this.$store.state.client.list[removingIdx].IsActive = false;
          // this.$alertMessage("成功刪除客戶「" + item.Name + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    reloadDataTable() {
      this.dataTable = this.$store.state.client.list.filter(o => o.IsActive);
      this.isDataRefetched = false;
      this.$store.state.client.isReloaded = false;
      this.tablePage = 1
    },
    onDataUpdated(item) {
      // let action = this.editingId >= 0 ? "編輯" : "新增";
      // this.$alertMessage("成功" + action + "客戶「" + item.Name + "」!");
      this.reloadDataTable();
    }
  },
  created() {
    if (this.myLevel < 10) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;
    this.$services.prepareDatas(this).then(() => {
      Promise.all([
        this.$services.client.prepareData(this),
        this.$services.county.prepareData(this)
      ])
        .then(this.reloadDataTable)
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  watch: {
    "$store.state.client.isReloaded"() {
      if (
        this.$store.state.client.isFetched &&
        this.$store.state.client.isReloaded
      )
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>